import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms-spinner"
export default class extends Controller {
  static targets = ["original", "spinner"]

  connect() {
    this.spinnerTarget.classList.add("hidden")

    this.clickListener = this.showSpinner.bind(this)
    this.element.addEventListener("click", this.clickListener)
  }

  disconnect() {
    this.element.removeEventListener("click", this.clickListener)
  }

  showSpinner(event) {
    this.originalTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")

    // Find the closest parent <li> and disable it
    const listItem = this.element.closest("li")
    if (listItem) {
      listItem.classList.add("disabled")
    }
  }
}

